import React from "react";

const DATA_IMAGES = [
  { id: 1, imgUrl: "https://via.placeholder.com/320x200.png?text=IMAGE" },
  { id: 2, imgUrl: "https://via.placeholder.com/320x200.png?text=IMAGE" },
  { id: 3, imgUrl: "https://via.placeholder.com/320x200.png?text=IMAGE" },
  { id: 4, imgUrl: "https://via.placeholder.com/320x200.png?text=IMAGE" },
  { id: 5, imgUrl: "https://via.placeholder.com/320x200.png?text=IMAGE" },
];

const DATA_COMPANY = [
  {
    id: 1,
    company: "Sony Ericson Corporation",
    about: "Mobie Phone Company",
    est: "1991",
    c_type: "Technology",
  },
  {
    id: 2,
    company: "Sony Codomo Corporation",
    about: "Mobie Phone Company",
    est: "1992",
    c_type: "Technology",
  },
  {
    id: 3,
    company: "Esia Corporation",
    about: "Mobie Phone Company",
    est: "1993",
    c_type: "Technology",
  },
  {
    id: 4,
    company: "Huawei Corporation",
    about: "Mobie Phone Company",
    est: "1994",
    c_type: "Technology",
  },
  {
    id: 5,
    company: "Acer Corporation",
    about: "Desktop Phone Company",
    est: "1995",
    c_type: "Technology",
  },
  {
    id: 6,
    company: "Asus Corporation",
    about: "Desktop Phone Company",
    est: "1996",
    c_type: "Technology",
  },
  {
    id: 7,
    company: "Xiaomi Corporation",
    about: "Desktop Phone Company",
    est: "1997",
    c_type: "Technology",
  },
  {
    id: 8,
    company: "Apple Corporation",
    about: "Desktop, Mobile, Tablet Phone Company",
    est: "1998",
    c_type: "Technology",
  },
  {
    id: 9,
    company: "LG Corporation",
    about: "Mobie Phone Company",
    est: "1999",
    c_type: "Technology",
  },
  {
    id: 10,
    company: "Samsung Corporation",
    about: "Mobie Phone Company",
    est: "1993",
    c_type: "Technology",
  },
];

const Screen = () => {
  const userRole = localStorage.getItem("role");
  return (
    <div className="h-screen">
      <div className="mt-10">
        <h1 className="font1 text-[28px] font-black text-red-700 text-center">
          WELCOME TO
        </h1>
        <div className="flex  justify-center mt-[-50px] mb-[-20px]">
          <img
            src="https://cdn.techinasia.com/data/images/cehKZpJlQKwD7r8NJSzWG9pwYANbdcRIcx61mPCq.png"
            alt=""
          />
          {/* <img src={"../../../../assets/images/logo-merah.png"}/> */}
        </div>
      </div>
      <div className="py-[20px] px-[60px] bg-[#fff] rounded-md shadow-xl mx-20 text-center">
        <h1 className="font2 text-[#333] text-[22px] leading-[1.15] font-semibold mb-2">
          About Us
        </h1>
        <div className="mb-6 text-lg leading-normal">
          Sagara Technology builds mission-driven technology that helps people
          to solve critical real-world problems. We create impact through
          digital, design, and hardware.
        </div>
        <div className="grid grid-cols-3 font1 font-bold text-red-700 text-[14px]">
          <p>NO: 08123456</p>
          <p>STARTED: NOV 2014</p>
          <p>EMAIL: Sagara@gmail.com</p>
        </div>
      </div>
      <div className="m-10">
        <h3 className="font2 ">ACTIVITY</h3>
        <div
          className={
            DATA_IMAGES.length > 3
              ? "flex space-x-6 py-6 overflow-x-scroll"
              : "flex space-x-6 py-6"
          }
        >
          {DATA_IMAGES.map((el, index) => {
            return (
              <>
                <img
                  className="rounded-md"
                  src={el.imgUrl}
                  alt=""
                  key={index}
                />
              </>
            );
          })}
        </div>
      </div>
      <div className="m-10">
        <h3 className="font2 ">PROJECTS</h3>
        <div className="flex space-x-6 mt-4">
          <div className="bg-black text-white py-5 w-1/3 space-x-6 rounded-t-lg text-center font3 font-semibold">
            Web Technology
          </div>
          <div className="bg-black text-white py-5 w-1/3 space-x-6 rounded-t-lg text-center font3 font-semibold">
            Mobile Technology
          </div>
          <div className="bg-black text-white py-5 w-1/3 space-x-6 rounded-t-lg text-center font3 font-semibold">
            Augmented Reality
          </div>
        </div>
        <div className="flex space-x-6">
          <div className="bg-white py-5 w-1/3 space-x-6 rounded-b-lg text-center font3 shadow-xl">
            We specialized web design
          </div>
          <div className="bg-white py-5 w-1/3 space-x-6 rounded-b-lg text-center font3 shadow-xl">
            We specialized mobile design
          </div>
          <div className="bg-white py-5 w-1/3 space-x-6 rounded-b-lg text-center font3 shadow-xl">
            We specialized 3D content
          </div>
        </div>
      </div>
      <div className={`m-10 ${userRole === "business" ? "hidden" : "static"}`}>
        <h3 className="font2 ">COMPANY</h3>
        <div className="overflow-x-auto relative shadow-md mt-4">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th className="py-3 px-6">No</th>
                <th className="py-3 px-6">Company Industry</th>
                <th className="py-3 px-6">About</th>
                <th className="py-3 px-6">Establish Date</th>
                <th className="py-3 px-6">Company Type</th>
              </tr>
            </thead>
            <tbody>
              {DATA_COMPANY.map((el, index) => {
                return (
                  <>
                    <tr className="bg-white border-b" key={index}>
                      <td className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap">
                        {index + 1}
                      </td>
                      <td className="py-4 px-6">{el.company}</td>
                      <td className="py-4 px-6">{el.about}</td>
                      <td className="py-4 px-6">{el.est}</td>
                      <td className="py-4 px-6">{el.c_type}</td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div
        className={`m-10 ${
          userRole === "business" ? "hidden pb-10" : "flex"
        } justify-center `}
      >
        <nav aria-label="Page navigation example">
          <ul class="flex list-style-none">
            <li class="page-item disabled">
              <a
                class="page-link relative block py-1.5 px-3 border-0 bg-transparent outline-none transition-all duration-300 rounded-full text-gray-500 pointer-events-none focus:shadow-none"
                href="#"
                tabindex="-1"
                aria-disabled="true"
              >
                Previous
              </a>
            </li>
            <li class="page-item active">
              <a
                class="page-link relative block py-1.5 px-3 border-0 bg-transparent outline-none transition-all duration-300 rounded-full text-gray-800 hover:text-gray-800 hover:bg-gray-200 focus:shadow-none"
                href="#"
              >
                1
              </a>
            </li>
            <li class="page-item ">
              <a
                class="page-link relative block py-1.5 px-3 border-0 bg-blue-600 outline-none transition-all duration-300 rounded-full text-white hover:text-white hover:bg-blue-600 shadow-md focus:shadow-md"
                href="#"
              >
                2
              </a>
            </li>
            <li class="page-item">
              <a
                class="page-link relative block py-1.5 px-3 border-0 bg-transparent outline-none transition-all duration-300 rounded-full text-gray-800 hover:text-gray-800 hover:bg-gray-200 focus:shadow-none"
                href="#"
              >
                3
              </a>
            </li>
            <li class="page-item">
              <a
                class="page-link relative block py-1.5 px-3 border-0 bg-transparent outline-none transition-all duration-300 rounded-full text-gray-800 hover:text-gray-800 hover:bg-gray-200 focus:shadow-none"
                href="#"
              >
                Next
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Screen;
